import Box from '~/core/Box'
import Text from '~/core/Text'
import {
    BLACK_ALPHA_BOTTOM,
    HEADER_STYLES,
} from '~/apps/consumer/components/PartViewerModal/logic'
import SafeDownloadLink from '~/apps/consumer/components/SafeDownloadLink'
import { AdditionalFilesType } from '~/apps/consumer/components/PartViewerModal/types'

export default function AdditionalFiles(props: AdditionalFilesType) {
    const { additionalDocs, placement } = props

    const description = additionalDocs.map(additionalDoc => {
        return (
            additionalDoc && (
                <SafeDownloadLink
                    key={additionalDoc.createdAt}
                    dataKey={additionalDoc.createdAt}
                    downloadUrl={additionalDoc.downloadUrl}
                    fileName={additionalDoc.fileName}
                    name="additional-files-link"
                    placement={placement}
                    data-test-target="additional-document"
                >
                    <Box
                        marginBottom="10px"
                        style={{ wordBreak: 'break-word' }}
                    >
                        {additionalDoc.fileName}
                    </Box>
                </SafeDownloadLink>
            )
        )
    })

    return (
        <Box direction="col" padding="16px 0" borderTop={BLACK_ALPHA_BOTTOM}>
            <Text style={HEADER_STYLES}>Additional files</Text>
            {description}
        </Box>
    )
}
